import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import Fa from 'react-fontawesome';
import qs from 'qs';
import { seq } from 'async';
import { withRouter, Link } from 'react-router-dom';
import { startsWith, find, filter, values, first, map } from 'lodash';
import ProgressBar from '../../../../components/progress-bar';
import requiredSetupMappings from '../../../../components/required-setup-mappings';
import requiredSync from '../../../../components/required-sync';
import orgAwearness from '../../../../components/organization-awearness';
import { fetchOpportunity, fetchAccount } from '../../ApexActions';
import RequiredTVCollectorMappingSetup from '../../../Setup/pages/TruVoiceCollectorsPage/RequiredTVCollectorMappingSetup';
import createRequestFeedbackComponent, { OPPORTUNITY_COMPONENT_TYPE, ACCOUNT_COMPONENT_TYPE } from '../../../Dashboard/components/WinLossOpportunityTable/RequestOpportunityFeedbacks';
import SurveyEmailModal from '../../../Dashboard/components/SurveyEmailModal';
import InsightModal from '../../../Feedback/components/sidebox/InsightModal';
import NumberDisplay from '../../../../components/number-display';
import { fetchTVProductMappings } from '../../../Setup/SetupActions';
import {
  getUser, getUserCurrentOrganization, getIsAdmin, getIsSuperAdmin, getIsUsingOrganizationSwitch,
} from '../../../Auth/AuthReducer';
import {
  fetchWinLossAllSellerFeedbacks,
  fetchWinLossOpportunitySurveys,
  fetchWinLossAccountSurveys,
  loadSettings,
  fetchWinLossAllFeedbacks,
  requestEditWinLossOpportunityFeedbacks,
  fetchInsights,
  winLossExcludeOpportunity,
  winLossIncludeOpportunity,
  winLossExcludeAccount,
  winLossIncludeAccount,
  winLossCancelSurveys,
  updateAccountStatus,
  requestEditWinLossAccountFeedbacks,
  fetchOpportunityRequestStatus,
} from '../../../Dashboard/DashboardActions';
import { getWinLossCollectorStats, getWinLossOpportunities, getWinLossAccounts, getFeedbackRequestStatus } from '../../../Dashboard/DashboardReducer';
import OpportunityBox from '../../../Feedback/components/opportunity-box';
import OutreachPlanModal from '../../../Feedback/components/outreach-plan-modal';
import EditSenderModal from '../../../Feedback/components/edit-sender-modal';
import EditLanguageModal from '../../../Feedback/components/edit-language-modal';
import AccountBox from '../../../Feedback/components/account-box';
import getMenus from '../../../App/components/Header/menu';
import Pusher from '../../../../components/pusher';
import AnimatedText from '../../../../components/animated-text';
import ExcludeOpportunityForm from '../../../Feedback/components/opportunity-box/ExcludeOpportunityForm';
import CancelOutreachForm from '../../../Feedback/components/opportunity-box/CancelOutReachForm';
import ColumnDataManager from '../../../../components/god-table/column-data-manager';


class ApexReceiver extends Component {
  constructor(props) {
    super(props);
    const isAccount = props.match?.params?.source === 'accounts';
    this.state = {
      loading: true,
      loaded: false,
      errors: null,
      done: false,
      statsLoading: false,
      current: 0,
      tabs: {},
      colorPalletes: {},
      currentSurveyPlan: null,
      currentEditSenderSurvey: null,
      automationSubmitting: false,
      currentlyExcludedOpportunity: null,
      currentlyExcludedAccount: null,
      currentEditLanguageSurvey: null,
      changeLanguageCallback: null,
      selectedLanguage: null,
      availableLanguages: [],
      currentCancelContact: null,
      cancelContactCallBack: null,
      automationId: null,
    };
    this.hanldeDone = this.hanldeDone.bind(this);
    this.handleAutomationContactSubmittedSuccess = this.handleAutomationContactSubmittedSuccess.bind(this);
    this.handleTabSelect = this.handleTabSelect.bind(this);
    this.handleOnAccountLogoLoaded = this.handleOnAccountLogoLoaded.bind(this);
    this.requestShowOutreachPlan = this.requestShowOutreachPlan.bind(this);
    this.requestChangeSenderEmail = this.requestChangeSenderEmail.bind(this);
    this.handleRequestAddOpportunitySurvey = this.handleRequestAddOpportunitySurvey.bind(this);
    this.handleSubmitted = this.handleSubmitted.bind(this);
    this.handleRequestShowInsight = this.handleRequestShowInsight.bind(this);
    this.handleAutomationContactSubmitting = this.handleAutomationContactSubmitting.bind(this);
    this.handleAutomationContactSubmitError = this.handleAutomationContactSubmitError.bind(this);
    this.handleExcludeOpportunity = this.handleExcludeOpportunity.bind(this);
    this.requestExcludeOpportunity = this.requestExcludeOpportunity.bind(this);
    this.handleIncludeOpportunity = this.handleIncludeOpportunity.bind(this);
    
    this.handleExcludeAccount = this.handleExcludeAccount.bind(this);
    this.requestExcludeAccount = this.requestExcludeAccount.bind(this);
    this.handleIncludeAccount = this.handleIncludeAccount.bind(this);
    
    this.requestChangeLanguage = this.requestChangeLanguage.bind(this);
    this.handleRequestCancelContact = this.handleRequestCancelContact.bind(this);
    this.handleCancelOutreach = this.handleCancelOutreach.bind(this);
    this.handleUpdateAccountStatus = this.handleUpdateAccountStatus.bind(this);
    this.RequestOpportunityFeedbacks = createRequestFeedbackComponent(isAccount ? ACCOUNT_COMPONENT_TYPE : OPPORTUNITY_COMPONENT_TYPE);
  }

  componentDidMount() {
    const { resourceId } = this.props.match.params;
    const query = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    const { automationId } = query;
    this.setState({ automationId });
    if (resourceId) {
      this.props.dispatch(loadSettings(automationId, this.props.isAccount));
      this.loadResource(resourceId);
    }
  }

  componentWillReceiveProps(nextProps) {
    const currentId = this.props.match.params.resourceId;
    const nextId = nextProps.match.params.resourceId;
    if (currentId !== nextId) {
      this.loadResource(nextId);
    }
  }

  handleRequestShowInsight(insightId) {
    const { resourceId } = this.props.match.params;
    this.props.dispatch(fetchInsights(resourceId, insightId));
  }

  handleTabSelect(tab) {
    const { resourceId } = this.props.match.params;
    this.setState({ tabs: { ...this.state.tabs, [resourceId]: tab } });
  }

  handleRequestAddOpportunitySurvey(opportunity, contact) {
    if (this.props.isAccount) {
      this.props.dispatch(requestEditWinLossAccountFeedbacks(opportunity));
    } else {
      this.props.dispatch(requestEditWinLossOpportunityFeedbacks(opportunity, contact));
    }
  }

  handleOnAccountLogoLoaded(accountLogoUrl, colorPallete) {
    const { resourceId } = this.props.match.params;
    this.setState({ colorPalletes: { ...this.state.colorPalletes, [resourceId]: colorPallete } });
  }

  handleExcludeOpportunity(opportunity, params) {
    const p = this.props.dispatch(winLossExcludeOpportunity(opportunity.opportunity_id, params));
    p.then(() => { this.props.dispatch(fetchWinLossOpportunitySurveys(opportunity.opportunity_id)); });
    return p;
  }

  handleExcludeAccount(account, params) {
    const p = this.props.dispatch(winLossExcludeAccount(account.account_id, params));
    p.then(() => { this.props.dispatch(fetchWinLossAccountSurveys(account.opportunity_id)); });
    return p;
  }

  requestExcludeOpportunity(currentlyExcludedOpportunity) {
    this.hanldeDone();
    this.setState({ currentlyExcludedOpportunity });
  }

  requestExcludeAccount(currentlyExcludedAccount) {
    this.hanldeDone();
    this.setState({ currentlyExcludedAccount });
  }

  requestChangeLanguage(currentEditLanguageSurvey, selectedLanguage, availableLanguages, changeLanguageCallback = () => {}) {
    this.setState({
      currentEditLanguageSurvey,
      selectedLanguage,
      availableLanguages,
      changeLanguageCallback,
    });
    return Promise.resolve();
  }

  handleRequestCancelContact(currentCancelContact, object, cancelContactCallBack = () => {}) {
    this.setState({ currentCancelContact, cancelContactCallBack });
  }

  handleUpdateAccountStatus(account, status) {
    return this.props.dispatch(updateAccountStatus(account.account_id, status));
  }


  handleCancelOutreach(contact, reason) {
    const { opportunity, isAccount } = this.props;
    const contactId = contact.id;
    const collectorId = contact.collector_id;
    const id = isAccount ? opportunity.account_id : opportunity.opportunity_id;
    const p = this.props.dispatch(winLossCancelSurveys(collectorId, id, contactId, isAccount, reason, contact));
    p.then(
      (c) => {
        if (this.state.cancelContactCallBack) {
          this.state.cancelContactCallBack(c);
          this.setState({ cancelContactCallBack: null });
        }
      },
    );
    return p;
  }

  requestShowOutreachPlan(survey) {
    this.setState({ currentSurveyPlan: { ...survey, object_id: this.props.opportunity.opportunity_id } });
    return Promise.resolve();
  }

  requestChangeSenderEmail(survey) {
    this.setState({
      currentEditSenderSurvey: {
        ...survey,
        object_id: this.props.opportunity.opportunity_id,
        object: this.props.opportunity,
      },
    });
    return Promise.resolve();
  }

  showSuccessToaster(resultContacts) {
    const { opportunity, account, isAccount } = this.props;
    let title = '';
    if (isAccount) {
      if (account && account.name) {
        title = (<span>&nbsp;for <strong>{account.name}</strong></span>);
      }
    } else if (opportunity && opportunity.name) {
      title = (<span>&nbsp;for <strong>{opportunity.name}</strong></span>);
    }
    
    if (resultContacts && resultContacts.length > 0) {
      const have = resultContacts.length === 1 ? 'has' : 'have';
      const el = (
        <div>
          <p>
            <NumberDisplay value={resultContacts.length} precision={0} suffix="contact" suffixIsUnit />
            {' '}
            {have} been added to the feedback request campaign{title}!
          </p>
          <ul>
            {resultContacts.map((e) => {
              const name = `${e.contact.first_name} ${e.contact.last_name}`;
              return (
                <li key={e.contact.contact_id}>
                  {name}
                </li>
              );
            })}
          </ul>
        </div>
      );
      this.context.addNotification(el, { type: 'success', autoClose: false });
    }
  }

  showErrorToaster(resultContacts) {
    if (!resultContacts || resultContacts.length === 0) {
      return;
    }
    const { opportunity } = this.props;
    let title = '';
    if (opportunity && opportunity.name) {
      title = (<span>&nbsp;for <strong>{opportunity.name}</strong></span>);
    }
    if (resultContacts && resultContacts.length > 0) {
      const have = resultContacts.length === 1 ? 'has' : 'have';
      const el = (
        <div>
          <p>
            <NumberDisplay value={resultContacts.length} precision={0} suffix="contact" suffixIsUnit />
            {' '}
            {have} NOT been added to the feedback request campaign{title}!
          </p>
          <ul>
            {resultContacts.map((e) => {
              const name = `${e.contact.first_name} ${e.contact.last_name}`;
              let reason = null;
              if (e.errors && e.errors.message) {
                reason = e.errors.message;
              }
              return (
                <li key={e.contact.contact_id}>
                  {name} {reason !== null && <div> - Reason: {reason}</div>}
                </li>
              );
            })}
          </ul>
        </div>
      );
      this.context.addNotification(el, { type: 'error', autoClose: false });
    }
  }

  handleSubmitted(opportunity, feedbacks, surveys, resultContacts, errorContacts) {
    if (errorContacts && errorContacts.length) {
      // do not thing, let the user fix the error
      return;
    }
    this.showSuccessToaster(resultContacts);
    if (this.props.isAccount) {
      this.props.dispatch(requestEditWinLossAccountFeedbacks(null));
    } else {
      this.props.dispatch(requestEditWinLossOpportunityFeedbacks(null));
    }
    this.setState({ done: true });
  }

  handleAutomationContactSubmittedSuccess(params) {
    if (params && params.resourceId === this.props.match.params.resourceId) {
      this.fetchFeedbacks(params.resourceId);
      this.props.dispatch(fetchWinLossOpportunitySurveys(params.resourceId))
        .then(
          () => {
            const { results } = params;
            const contacts = values(results);
            if (contacts && contacts.length) {
              const resultContacts = filter(contacts, { success: true });
              const resultErrorContacts = filter(contacts, { success: false });

              this.showSuccessToaster(resultContacts);
              this.showErrorToaster(resultErrorContacts);
            }
            this.setState({ automationSubmitting: false, current: this.state.current + 1 });
          },
          () => {
            this.setState({ automationSubmitting: false });
          },
        );
    }
  }

  handleAutomationContactSubmitting(params) {
    if (params && params.resourceId === this.props.match.params.resourceId) {
      this.setState({ automationSubmitting: true });
    }
  }

  handleIncludeOpportunity(opportunity) {
    const p = this.props.dispatch(winLossIncludeOpportunity(opportunity.opportunity_id));
    return p;
  }

  handleIncludeAccount(account) {
    const p = this.props.dispatch(winLossIncludeAccount(account.account_id));
    return p;
  }

  handleAutomationContactSubmitError(params) {
    if (params && params.resourceId === this.props.match.params.resourceId) {
      const e = params.error || {};
      this.setState({ automationSubmitting: false });
      const el = (
        <div>
          <p>
            {(e.message || 'Automation Contact Submit Error.')}
          </p>
        </div>
      );
      this.context.addNotification(el, { type: 'error', autoClose: false });
      this.fetchFeedbacks(params.resourceId);
    }
  }

  fetchFeedbacks(resourceId) {
    this.setState({ statsLoading: true }, () => {
      fetchWinLossAllFeedbacks(this.props.dispatch, [resourceId])
        .then(() => { this.setState({ statsLoading: false }); });
    });
  }

  hanldeDone() {
    if (this.props.isAccount) {
      this.props.dispatch(requestEditWinLossAccountFeedbacks(null));
    } else {
      this.props.dispatch(requestEditWinLossOpportunityFeedbacks(null));
    }
    this.setState({ done: true });
  }


  checkFeedback() {
    const { statsLoading, loaded } = this.state;
    if (!loaded || statsLoading) {
      return;
    }
    const {
      collectorStats,
      match: { params: { resourceId } },
    } = this.props;
    const stats = collectorStats[resourceId];
    if (stats && stats.total > 0) {
      this.hanldeDone();
    }
  }

  loadResource(resourceId) {
    if (!this.state.loaded) {
      this.setState({
        loading: true, loaded: false, errors: null, statsLoading: true,
      }, () => {
        const { location: { pathname }, isAccount } = this.props;
        seq(
          (callback) => {
            this.props.dispatch(fetchTVProductMappings())
              .then(
                () => {
                  callback(null, true);
                },
                (e) => {
                  callback(e);
                },
              );
          },
          (fetchedProducts, callback) => {
            this.props.dispatch(isAccount ? fetchAccount(resourceId) : fetchOpportunity(resourceId))
              .then(
                (opportunity) => {
                  const syncedId = isAccount ? opportunity.account_id : opportunity.opportunity_id;
                  if (resourceId !== syncedId) {
                    // redirect
                    this.context.router.history.push({ pathname: pathname.replace(resourceId, syncedId) });
                    callback(false);
                    return;
                  }
                  callback(null, opportunity);
                },
                (errors) => {
                  callback(errors);
                },
              );
          },
          (opportunity, callback) => {
            const syncedId = isAccount ? opportunity.account_id : opportunity.opportunity_id;
            fetchWinLossAllFeedbacks(this.props.dispatch, [syncedId], isAccount)
              .then(
                () => {
                  this.setState({ statsLoading: false }, () => {
                    callback(null, opportunity);
                  }); 
                },
                (e) => {
                  callback(e);
                },
              );
          },
          (opportunity, callback) => {
            let stateId = null;
            let requestedIds = [];

            if (isAccount) {
              stateId = opportunity.account_id;
              requestedIds = map(opportunity.opportunities, 'opportunity_id');
            } else {
              stateId = opportunity.opportunity_id;
              requestedIds = [opportunity.opportunity_id];
            }
            this.props.dispatch(fetchOpportunityRequestStatus([stateId], requestedIds, isAccount ? 'account' : 'opportunity'))
              .then(
                (results) => {
                  let feedbackRequestable = false;
                  if (isAccount) {
                    const anyQualified = find(results, { feedbackRequestable: true });
                    feedbackRequestable = (anyQualified && anyQualified.feedbackRequestable === true) || results.feedback_requestable === true;
                  } else {
                    const anyQualified = results[stateId];
                    feedbackRequestable = (anyQualified && anyQualified.feedbackRequestable === true) || results.feedback_requestable === true;
                  }
                  if (feedbackRequestable) {
                    callback(null, opportunity);
                  } else {
                    callback(new Error(`This ${isAccount ? 'account' : 'opportunity'} did not match any automation trigger conditions and, therefore, is not available for requesting feedbacks`));
                  }
                },
                (e) => {
                  callback(e);
                },
              );
          },
          (opportunity, callback) => {
            const { organization, user } = this.props;
            let shouldHandleSellerFeedbacks = false;
            if (organization.seller_reasons_enabled) {
              shouldHandleSellerFeedbacks = (organization.seller_reasons_public || opportunity.owner_id === user.user_id);
            }
            if (!isAccount && shouldHandleSellerFeedbacks) {
              fetchWinLossAllSellerFeedbacks(this.props.dispatch, [opportunity.opportunity_id])
                .then(
                  () => {
                    callback(null, true);
                  },
                  (e) => {
                    callback(e);
                  },
                );
            } else {
              callback(null, true);
            }
          },
        )((errors) => {
          if (errors) {
            this.setState({ loading: false, loaded: false, errors: errors.data || errors }, () => {
              this.checkFeedback();
            });
          } else {
            this.setState({ loading: false, loaded: true, errors: null }, () => {
              this.checkFeedback();
            });
          }
        });
      });
    }
  }

  renderErrors() {
    const { errors } = this.state;
    const message = errors.message || 'It looks like something went wrong. Please let us know what you were trying to do and we will investigate right away. Thank you!';
    return (
      <div style={{ marginTop: 30 }} className="alert alert-danger">
        <p>{message}</p>
      </div>
    );
  }

  renderContent() {
    const { automationId } = this.state;
    const { opportunity, user, isAccount } = this.props;
    const isExcluded = opportunity.exclusion !== null && opportunity.exclusion !== undefined;
    return (
      <div>
        {!isAccount && isExcluded &&
          <ExcludeOpportunityForm
            opportunity={opportunity}
            auth={user}
            isModal={false}
            requestInclude={this.handleIncludeOpportunity}
          />
        }

        <this.RequestOpportunityFeedbacks
          isModal={false}
          onDone={this.hanldeDone}
          onSuccess={this.handleSubmitted}
          withSummary
          withPreferCollector
          collectorTypes={isAccount ? ['experience'] : ['decision']}
          title={this.renderTitle()}
          requestCancelContact={this.handleRequestCancelContact}
          requestChangeLanguage={this.requestChangeLanguage}
          requestExclude={this.requestExcludeOpportunity}
          automationId={automationId}
        />

        <SurveyEmailModal dateLabel="Send Date" title="Email Outreach Plan" />
        <p />
      </div>
    );
  }


  renderTitle() {
    const { opportunity, feedbackMenu, isAccount } = this.props;
    let { name } = opportunity;
    if (isAccount) {
      name = opportunity?.account?.name;
    }
    let title = (<span>Request Feedback For {name}</span>);
    if (feedbackMenu) {
      title = (
        <span>
          <Link to={feedbackMenu.url}>{isAccount ? 'Experience' : 'Decision'} Feedback</Link>
          {' '}
          <Fa name="chevron-right" className="text-muted" />
          {' '}
          Request Feedback For {name}
        </span>
      );
    }
    return <h5>{title}</h5>;
  }

  renderDone() {
    const {
      statsLoading,
      currentSurveyPlan,
      currentEditSenderSurvey,
      tabs,
      colorPalletes,
      currentlyExcludedOpportunity,
      currentlyExcludedAccount,
      automationId,
    } = this.state;
    const {
      collectorStats,
      match: { params: { resourceId } },
      user,
      opportunity,
      feedbackMenu,
      isAccount,
      account,
    } = this.props;

    if (statsLoading) {
      return (
        <div>
          <p>one moment please...</p>
          <ProgressBar />
        </div>
      );
    }
    if (!opportunity) {
      return null;
    }

    let doneBtn = null;
    if (feedbackMenu) {
      doneBtn = (
        <div className="text-right">
          <p />
          <Link className="btn btn-default" to={feedbackMenu.url}>Done</Link>
        </div>
      );
    }

    return (
      <div style={{ paddingTop: '15px' }}>
        {this.renderTitle()}
        {isAccount &&
          <AccountBox
            auth={user}
            isVisible
            account={account}
            collectorStats={collectorStats[resourceId]}
            measure={() => {}}
            onTabSelect={this.handleTabSelect}
            onLogoLoaded={this.handleOnAccountLogoLoaded}
            requestShowInsight={this.handleRequestShowInsight}
            requestAddAccountSurvey={this.handleRequestAddOpportunitySurvey}
            tab={tabs[resourceId]}
            colorPallete={colorPalletes[resourceId]}
            requestShowOutreachPlan={this.requestShowOutreachPlan}
            requestChangeSenderEmail={this.requestChangeSenderEmail}
            requestChangeLanguage={this.requestChangeLanguage}
            requestCancelContact={this.handleRequestCancelContact}
            isLast={false}
            updateAccountStatus={this.handleUpdateAccountStatus}
            excludeAccount={this.requestExcludeAccount}
            includeAccount={this.handleIncludeAccount}
          />
        }

        {!isAccount &&
          <OpportunityBox
            auth={user}
            isVisible
            opportunity={opportunity}
            collectorStats={collectorStats[resourceId]}
            measure={() => {}}
            onTabSelect={this.handleTabSelect}
            onLogoLoaded={this.handleOnAccountLogoLoaded}
            requestShowInsight={this.handleRequestShowInsight}
            requestAddOpportunitySurvey={this.handleRequestAddOpportunitySurvey}
            tab={tabs[resourceId]}
            colorPallete={colorPalletes[resourceId]}
            excludeOpportunity={this.requestExcludeOpportunity}
            includeOpportunity={this.handleIncludeOpportunity}
            requestShowOutreachPlan={this.requestShowOutreachPlan}
            requestChangeSenderEmail={this.requestChangeSenderEmail}
            requestChangeLanguage={this.requestChangeLanguage}
            isLast={false}
            sellerReasonsEnabled={false}
            requestCancelContact={this.handleRequestCancelContact}
            enableChangeCommnunicationRecipient={false}
          />
        }


        <OutreachPlanModal
          survey={currentSurveyPlan}
          onClose={() => { this.setState({ currentSurveyPlan: null }); }}
        />
        <EditSenderModal
          survey={currentEditSenderSurvey}
          onClose={() => { this.setState({ currentEditSenderSurvey: null }); }}
          onSuccess={() => {}}
        />
        
        <SurveyEmailModal />
        
        <InsightModal />

        <this.RequestOpportunityFeedbacks
          collectorTypes={isAccount ? ['experience'] : ['decision']}
          withPreferCollector
          requestCancelContact={this.handleRequestCancelContact}
          requestChangeLanguage={this.requestChangeLanguage}
          requestExclude={this.requestExcludeOpportunity}
          automationId={automationId}
        />

        <ExcludeOpportunityForm
          isAccount={isAccount}
          opportunity={isAccount ? currentlyExcludedAccount : currentlyExcludedOpportunity}
          auth={this.props.user}
          show={isAccount ? currentlyExcludedAccount !== null : currentlyExcludedOpportunity !== null}
          onClose={() => { this.setState({ currentlyExcludedAccount: null, currentlyExcludedOpportunity: null }); }}
          requestExclude={isAccount ? this.handleExcludeAccount : this.handleExcludeOpportunity}
        />

        <ColumnDataManager 
          id={isAccount ? 'account-feedback-tile' : 'feedback-tile'}
          key={this.props.match.params.resourceId}
          getRowData={() => [opportunity]}
          resourceType={isAccount ? 'ACCOUNT' : 'OPPORTUNITY'}
          onColumnLoaded={() => {}}
          forceLoadSystemColumnTags={['productDetails', 'contactDetails']}
        />

        {doneBtn}
        <div style={{ height: 400 }} />
      </div>
    );
  }

  render() {
    const {
      loading, loaded, done,
      errors, automationSubmitting,
    } = this.state;
    const { isStandalone, opportunity, isAccount } = this.props;
    const style = { padding: '40px 0' };
    let name = 'Your opportunity';
    if (opportunity) {
      ({ name } = opportunity);
    }
    return (
      <div>
        <Helmet title={isStandalone ? 'Apex Receiver' : 'Request Feedback'} />
        <div className="container">
          <Pusher key={`${this.props.match.params.resourceId}-submitting`} event="tv.collector.contactSubmitting" handler={this.handleAutomationContactSubmitting} />
          <Pusher key={`${this.props.match.params.resourceId}-error`} event="tv.collector.contactSubmittedError" handler={this.handleAutomationContactSubmitError} />
          <Pusher key={`${this.props.match.params.resourceId}-success`} event="tv.collector.contactSubmitted" handler={this.handleAutomationContactSubmittedSuccess} />
          <div key={this.state.current} style={style}>
            <RequiredTVCollectorMappingSetup types={isAccount ? ['experience'] : ['decision']}>
              {() => (
                <div>
                  {done && this.renderDone()}
                  {!done &&
                    <div>
                      {loading &&
                        <div style={{ paddingTop: 70 }}>
                          <AnimatedText text={`Syncing ${isAccount ? 'account' : 'opportunity'}`} />
                          <p>One moment please, syncing latest {isAccount ? 'account' : 'opportunity'} information...</p>
                          <ProgressBar />
                        </div>
                      }
                      {!loading && errors !== null && this.renderErrors()}
                      {!loading && loaded &&
                        <div>
                          {!automationSubmitting && this.renderContent()}
                          {automationSubmitting &&
                            <div style={{ paddingTop: 70 }}>
                              <AnimatedText text="Submitting contacts" />
                              <p>
                                One moment please, TruSales is submitting contacts for <strong>{name}</strong> to
                                request feedback on their experience. When this window refreshes you will see which contacts
                                were submitted and can modify or cancel as needed.
                              </p>
                              <ProgressBar />
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                  <EditLanguageModal
                    survey={this.state.currentEditLanguageSurvey}
                    selectedLanguage={this.state.selectedLanguage}
                    availableLanguages={this.state.availableLanguages}
                    onClose={() => {
                      this.setState({
                        currentEditLanguageSurvey: null,
                        selectedLanguage: null,
                        availableLanguages: [],
                        changeLanguageCallback: null,
                      }); 
                    }}
                    onSuccess={(c) => {
                      if (this.state.changeLanguageCallback) {
                        this.state.changeLanguageCallback(c);
                        this.setState({ changeLanguageCallback: null });
                      }
                    }}
                  />
                  {this.state.currentCancelContact !== null &&
                    <CancelOutreachForm
                      show
                      contact={this.state.currentCancelContact}
                      onClose={() => { this.setState({ currentCancelContact: null, cancelContactCallBack: null }); }}
                      onRequestCancel={this.handleCancelOutreach}
                    />
                  }
                </div>
              )}
            </RequiredTVCollectorMappingSetup>
          </div>
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  const { location: { pathname }, match } = ownProps;
  const isStandalone = startsWith(pathname, '/apex');
  const user = getUser(state);
  const organization = getUserCurrentOrganization(state);
  const canSeeAllPages = getIsAdmin(state) || getIsSuperAdmin(state) || getIsUsingOrganizationSwitch(state);

  const menus = getMenus(user, organization, canSeeAllPages);
  const feedbackMenu = find(menus, { componentKey: 'feedback' });

  const opportunity = first(getWinLossOpportunities(state));
  const account = first(getWinLossAccounts(state));
  return {
    isStandalone,
    organization,
    user,
    feedbackMenu,
    opportunity,
    account,
    canSeeAllPages: getIsAdmin(state) || getIsSuperAdmin(state) || getIsUsingOrganizationSwitch(state),
    collectorStats: getWinLossCollectorStats(state),
    isAccount: match?.params?.source === 'accounts',
    feedbackRequestStatus: getFeedbackRequestStatus(state, match?.params?.id),
  };
}

ApexReceiver.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isStandalone: PropTypes.bool,
  match: PropTypes.shape({
    params: PropTypes.shape({
      resourceId: PropTypes.string,
    }),
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
  organization: PropTypes.shape({
    seller_reasons_public: PropTypes.bool,
    seller_reasons_enabled: PropTypes.bool,
  }).isRequired,
  feedbackMenu: PropTypes.shape({
    url: PropTypes.string,
  }),
  user: PropTypes.shape({
    user_id: PropTypes.string,
  }).isRequired,
  collectorStats: PropTypes.shape({}),
  opportunity: PropTypes.shape({
    opportunity_id: PropTypes.string,
    automationId: PropTypes.string,
  }),
  account: PropTypes.shape({
    account_id: PropTypes.string,
    // automationId: PropTypes.string,
  }),
  isAccount: PropTypes.bool,
  feedbackRequestStatus: PropTypes.shape({}),
};
ApexReceiver.defaultProps = {
  isStandalone: false,
  feedbackMenu: null,
  opportunity: {},
  account: {},
  collectorStats: {},
  isAccount: false,
  feedbackRequestStatus: {},
};

ApexReceiver.contextTypes = {
  router: PropTypes.object,
  addNotification: PropTypes.func.isRequired,
};
export default connect(mapStateToProps)(orgAwearness(requiredSync(requiredSetupMappings(withRouter(ApexReceiver), ['stage', 'dealType']))));
